import { useCallback, useState } from "react";

import getMenuItemsV3, {
  GetMenuItemsV3Params,
} from "@/api/requests/consumerApi/getMenuItemsV3";
import { MenuItemCard } from "@/custom-types/MenuItemCard";

import {
  MenuFiltersGroup,
  MenuFiltersToggle,
  Response,
} from "../types/MenuFilters";

const useMenuFilterSearch = () => {
  const [results, setResults] = useState<Response>({
    availableFilters: [],
    availableSorts: [],
    menuItems: [],
    supportedFilters: [],
    totalItems: 0,
  });
  const [loading, setLoading] = useState(true);

  const searchMenuItems = useCallback(
    async (
      lat: number,
      lon: number,
      searchParams: GetMenuItemsV3Params,
      loadMore?: boolean,
    ) => {
      const { take = 15 } = searchParams;
      // only need to set loading state if a new filter was selected.
      // loadMore indicates the show more results was selected.
      setLoading(!loadMore);
      const {
        data: {
          metadata: { availableSorts, availableFilters, ...metadata },
          data: menuItems,
        },
      } = await getMenuItemsV3(lat, lon, { ...searchParams, take: take });

      setResults({
        availableFilters: availableFilters as (
          | MenuFiltersGroup
          | MenuFiltersToggle
        )[],
        availableSorts,
        menuItems: loadMore
          ? [...(results.menuItems as MenuItemCard[]), ...menuItems]
          : menuItems,
        supportedFilters: metadata?.supportedFilters || [],
        totalItems: metadata?.totalCount,
      });
      setLoading(false);
    },
    [setResults, results, setLoading],
  );

  return {
    loading,
    results,
    searchMenuItems,
  };
};

export default useMenuFilterSearch;
